import { Action } from '@ngrx/store';
import { EntryStatus } from '../../../_generated';
import { ParameterStoreValue } from '../../../data-entry/models/parameters.type';
export enum ParameterValuesAction {
  Set = '[ParameterValues] Set',
  UpdateId = '[ParameterValues] UpdateId',
  DeleteId = '[ParameterValues] DeleteId',
  Reset = '[ParameterValues] Reset',
  UpdateError = '[ParameterValues] UpdateError',
}

interface ParameterActionPayload {
  query: string;
  value: ParameterStoreValue;
}

interface ParameterIdActionPayload {
  query: string;
  id: number;
  status: EntryStatus;
}

interface ParameterDeleteIdActionPayload {
  query: string;
  id: number;
}

interface ParameterErrorActionPayload {
  query: string;
  hasError: boolean;
}

export class Set implements Action {
  readonly type = ParameterValuesAction.Set;

  constructor(public payload: ParameterActionPayload) {}
}

export class UpdateId implements Action {
  readonly type = ParameterValuesAction.UpdateId;

  constructor(public payload: ParameterIdActionPayload) {}
}

export class DeleteId implements Action {
  readonly type = ParameterValuesAction.DeleteId;

  constructor(public payload: ParameterDeleteIdActionPayload) {}
}

export class Reset implements Action {
  readonly type = ParameterValuesAction.Reset;
}

export class UpdateError implements Action {
  readonly type = ParameterValuesAction.UpdateError;

  constructor(public payload: ParameterErrorActionPayload) {}
}

export type ParameterValuesActionType = Set | UpdateId | DeleteId | Reset | UpdateError;
